// A scanned page's display rotation — 0, 90, 180 or 270 degrees clockwise,
// saved per page by an admin (server/lib/pageRotation.js) and applied with CSS
// by every viewer. The stored file itself is never rewritten.

const ROTATIONS = [0, 90, 180, 270];

// The page's rotation as one of the four quarter turns; anything unknown
// (an older API response without the field, a bad value) shows the page as
// uploaded.
export function pageRotation(file) {
  const n = Number(file?.rotation);
  return ROTATIONS.includes(n) ? n : 0;
}

// One quarter turn further clockwise: 0 → 90 → 180 → 270 → 0.
export function nextRotation(rotation) {
  const n = ROTATIONS.includes(Number(rotation)) ? Number(rotation) : 0;
  return (n + 90) % 360;
}

// A quarter turn swaps the page's width and height, so the viewer has to lay
// it out differently; 180 only flips it in place.
export const isQuarterTurn = (rotation) => rotation === 90 || rotation === 270;
